import { useMemo } from 'react';

import { StructuredMeasurements } from '@restDataAccess';
import { MeasurementRange } from '@scaleaq/sitecontrol-lib';

import Highcharts from '@/components/chart/highcharts';
import { fromApiDateTime } from '@/utils';

import { highchartsCautionRenderer, highchartsCautionRendererXAxisOffset } from '../../../icons.ts';

Highcharts.SVGRenderer.prototype.symbols.lowDataCapture = highchartsCautionRendererXAxisOffset;
Highcharts.SVGRenderer.prototype.symbols.lowDataCaptureLegend = highchartsCautionRenderer;

export const useLowDataCapture = (
  lowDataCaptureThreshold: number | undefined,
  measurements: StructuredMeasurements<MeasurementRange> | undefined
) => {
  return useMemo<[number, number][]>(() => {
    if (!measurements || !lowDataCaptureThreshold) return [];
    const lowDataCaptureXValues: Set<number> = new Set();

    Object.values(measurements).forEach(plotMeasurements =>
      Object.values(plotMeasurements).forEach(sensorMeasurements =>
        sensorMeasurements
          .filter(m => m.count < lowDataCaptureThreshold)
          .forEach(m => {
            lowDataCaptureXValues.add(fromApiDateTime(m.timestamp).toMillis());
          })
      )
    );

    return Array.from(lowDataCaptureXValues, x => [x, 0]);
  }, [lowDataCaptureThreshold, measurements]);
};
